import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnIN: CultureInfo = {
  name: 'en-IN',
  displayName: 'English (India)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-IN',
  parent: CultureInfoEn
};
